// src/data/geo/cities.js

export const CITY_COORDS = {
  /* =================================================
     🇹🇷 TURKEY — cities
  ================================================= */

  istanbul: [28.9784, 41.0082],
  ankara: [32.8597, 39.9334],
  izmir: [27.1428, 38.4237],
  bursa: [29.061, 40.195],
  antalya: [30.7133, 36.8969],
  adana: [35.3213, 37.0],
  konya: [32.4846, 37.8714],
  kayseri: [35.4853, 38.7225],
  gaziantep: [37.3833, 37.0662],
  mersin: [34.6447, 36.8121],
  kocaeli: [29.9167, 40.7667],
  aydin: [27.8396, 37.856],
  samsun: [36.3300, 41.2867],
  sakarya: [30.4000, 40.7833],
  hatay: [36.2300, 36.2000],
  diyarbakir: [40.2300, 37.9100],
  afyonkarahisar: [30.5400, 38.7500],
  manisa: [27.4300, 38.6100],
  malatya: [38.3500, 38.3500],
  erzurum: [41.2700, 39.9000],
  van: [43.3800, 38.4900],
  batman: [41.1300, 37.8800],
  elazig: [39.2200, 38.6800],
  denizli: [29.0800, 37.7800],
  sivas: [37.0300, 39.7500],
  gebze: [29.4300, 40.8000],
  sanliurfa: [38.7900, 37.1500],
  eskişehir: [30.5200, 39.7800],
  eskisehir: [30.5200, 39.7800],
  kahramanmaras: [36.9300, 37.5800],
  mugla: [28.3600, 37.2200],
  balikesir: [27.8800, 39.6500],
  trabzon: [39.7200, 41.0000],
  ordu: [37.8800, 40.9800],
  corum: [34.9500, 40.5500],
  rize: [40.5200, 41.0200],
  giresun: [38.3900, 40.9200],
  zonguldak: [31.7900, 41.4500],
  kutahya: [29.9800, 39.4200],
  osmaniye: [36.2000, 37.0700],
  canakkale: [26.4100, 40.1500],
  tekirdag: [27.5200, 40.9800],
  tekirdağ: [27.5200, 40.9800],
  kirikkale: [33.5100, 39.8500],
  agri: [43.0500, 39.7200],
  edirne: [26.5600, 41.6800],
  tokat: [36.5500, 40.3100],
  bolu: [31.6000, 40.7300],
  nevsehir: [34.7200, 38.6200],
  nevşehir: [34.7200, 38.6200],
  yozgat: [34.8000, 39.8200],
  karabuk: [32.6200, 41.2000],
  karabük: [32.6200, 41.2000],
  siirt: [41.9400, 37.9300],
  adiyaman: [38.2800, 37.7600],
  adıyaman: [38.2800, 37.7600],
  uşak: [29.4100, 38.6800],
  usak: [29.4100, 38.6800],
  kirklareli: [27.2200, 41.7300],
  kırklareli: [27.2200, 41.7300],
  gümüşhane: [39.4800, 40.4600],
  gumushane: [39.4800, 40.4600],
  bingol: [40.5000, 38.8800],
  bingöl: [40.5000, 38.8800],
  bitlis: [42.1100, 38.4000],
  artvin: [41.8200, 41.1800],
  igdir: [44.0400, 39.9200],
  ığdır: [44.0400, 39.9200],
  ardahan: [42.7000, 41.1100],
  tunceli: [39.1100, 39.1000],
  bayburt: [40.2600, 40.2600],
  kilis: [37.1200, 36.7200],
  hakkari: [43.7400, 37.5700],
  şırnak: [42.4600, 37.5200],
  sirnak: [42.4600, 37.5200],
  mardin: [40.7400, 37.3100],

  /* =================================================
     🇩🇪 GERMANY — cities
  ================================================= */

  berlin: [13.4050, 52.5200],
  hamburg: [9.9937, 53.5511],
  munich: [11.5820, 48.1351],
  munchen: [11.5820, 48.1351],

  frankfurt: [8.6821, 50.1109],
  "frankfurt am main": [8.6821, 50.1109],

  cologne: [6.9603, 50.9375],
  koln: [6.9603, 50.9375],

  dusseldorf: [6.7735, 51.2277],
  duesseldorf: [6.7735, 51.2277],

  stuttgart: [9.1829, 48.7758],
  dortmund: [7.4653, 51.5136],
  essen: [7.0123, 51.4556],
  leipzig: [12.3731, 51.3397],
  bremen: [8.8017, 53.0793],
  hannover: [9.7320, 52.3759],

  /* =================================================
     🇬🇧 UNITED KINGDOM — cities
  ================================================= */

  london: [-0.1276, 51.5074],
  manchester: [-2.2426, 53.4808],
  birmingham: [-1.8904, 52.4862],
  glasgow: [-4.2518, 55.8642],
  liverpool: [-2.9916, 53.4084],
  edinburgh: [-3.1883, 55.9533],
  leeds: [-1.5491, 53.8008],
  bristol: [-2.5879, 51.4545],
  sheffield: [-1.4701, 53.3811],
  newcastle: [-1.6178, 54.9783],

  /* =================================================
     🇫🇷 FRANCE — cities
  ================================================= */

  paris: [2.3522, 48.8566],
  marseille: [5.3698, 43.2965],
  lyon: [4.8357, 45.7640],
  toulouse: [1.4442, 43.6047],
  nice: [7.2619, 43.7102],
  nantes: [-1.5534, 47.2184],
  strasbourg: [7.7521, 48.5734],
  montpellier: [3.8767, 43.6108],
  bordeaux: [-0.5792, 44.8378],
  lille: [3.0573, 50.6292],

  /* =================================================
     🇮🇹 ITALY — cities
  ================================================= */

  rome: [12.4964, 41.9028],
  milan: [9.1900, 45.4642],
  naples: [14.2681, 40.8518],
  turin: [7.6869, 45.0703],
  palermo: [13.3615, 38.1157],
  bologna: [11.3426, 44.4949],
  florence: [11.2558, 43.7696],

  /* =================================================
     🇪🇸 SPAIN — cities
  ================================================= */

  madrid: [-3.7038, 40.4168],
  barcelona: [2.1734, 41.3851],
  valencia: [-0.3763, 39.4699],
  seville: [-5.9845, 37.3891],
  malaga: [-4.4214, 36.7213],
  bilbao: [-2.9350, 43.2630],

  /* =================================================
     🇳🇱 NETHERLANDS — cities
  ================================================= */

  amsterdam: [4.9041, 52.3676],
  rotterdam: [4.4792, 51.9244],
  thehague: [4.3007, 52.0705],
  utrecht: [5.1214, 52.0907],

  /* =================================================
     🇧🇪 BELGIUM — cities
  ================================================= */

  brussels: [4.3517, 50.8503],
  antwerp: [4.4025, 51.2194],
  ghent: [3.7174, 51.0543],

  /* =================================================
     🇦🇹 AUSTRIA — cities
  ================================================= */

  vienna: [16.3738, 48.2082],
  graz: [15.4395, 47.0707],
  linz: [14.2858, 48.3069],

  /* =================================================
     🇨🇭 SWITZERLAND — cities
  ================================================= */

  zurich: [8.5417, 47.3769],
  geneva: [6.1432, 46.2044],
  basel: [7.5886, 47.5596],

  /* =================================================
     🇸🇪 SWEDEN — cities
  ================================================= */

  stockholm: [18.0686, 59.3293],
  gothenburg: [11.9746, 57.7089],
  malmo: [13.0038, 55.6050],

  /* =================================================
     🇳🇴 NORWAY — cities
  ================================================= */

  oslo: [10.7522, 59.9139],
  bergen: [5.3221, 60.39299],

  /* =================================================
     🇩🇰 DENMARK — cities
  ================================================= */

  copenhagen: [12.5683, 55.6761],

  /* =================================================
     🇵🇱 POLAND — cities
  ================================================= */

  warsaw: [21.0122, 52.2297],
  krakow: [19.94498, 50.0647],
  wroclaw: [17.0385, 51.1079],

  /* =================================================
     🇨🇿 CZECHIA — cities
  ================================================= */

  prague: [14.4378, 50.0755],

  /* =================================================
   🌍 NORTH AFRICA — cities
================================================= */

   cairo: [31.2357, 30.0444],
   alexandria: [29.9187, 31.2001],
   giza: [31.2118, 30.0131],

   casablanca: [-7.5898, 33.5731],
   rabat: [-6.8498, 34.0209],
   marrakesh: [-7.9811, 31.6295],
   marrakech: [-7.9811, 31.6295],

   algiers: [3.0588, 36.7538],
   oran: [-0.6417, 35.6971],
   constantine: [6.6147, 36.3650],

   tunis: [10.1658, 36.8065],
   sfax: [10.7603, 34.7406],
   sousse: [10.63699, 35.82539],

   tripoli: [13.1913, 32.8872],
   benghazi: [20.0667, 32.1167],

   khartoum: [32.5599, 15.5007],
   omdurman: [32.4800, 15.6445],

   /* =================================================
      🕌 ARABIAN PENINSULA — cities
   ================================================= */

   riyadh: [46.6753, 24.7136],
   jeddah: [39.1979, 21.4858],
   mecca: [39.8579, 21.3891],
   makkah: [39.8579, 21.3891],
   medina: [39.5692, 24.5247],
   madinah: [39.5692, 24.5247],
   dammam: [50.1033, 26.4207],

   dubai: [55.2708, 25.2048],
   abudhabi: [54.3773, 24.4539],
   sharjah: [55.4033, 25.3463],

   doha: [51.5310, 25.2854],

   kuwaitcity: [47.9774, 29.3759],

   manama: [50.5860, 26.2235],

   muscat: [58.4059, 23.5880],

   sanaa: [44.2075, 15.3694],
   aden: [45.0364, 12.7855],

   amman: [35.9304, 31.9454],
   zarqa: [36.0879, 32.0728],

   beirut: [35.5018, 33.8938],

   damascus: [36.2777, 33.5147],
   aleppo: [37.1587, 36.2021],

   baghdad: [44.3661, 33.3152],
   basra: [47.7804, 30.5085],
   erbil: [44.0090, 36.1911],

};

export default CITY_COORDS;
